export default "__VITE_ASSET__D5vy$aXM__"